import { Navigate, Route, Routes } from 'react-router';
import { PageSignIn } from './modules/authentication';
import { PagePlayer } from './modules/player/containers';
import { Toaster } from 'components/shadcn/sonner';
import { InfoRoute, ResetRoute, useAppStateContext } from './shared';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'components/custom';

// "/" is the whole app for a TV: the pairing screen until an admin adds it, then playback.
// Pairing (or forgetting) the screen swaps the view in place, so there is nothing to redirect.
const Home = () => {
  const { appState } = useAppStateContext();
  const isPaired =
    Boolean(appState?.tid) && Boolean(appState?.screenInfo?.accessToken);

  return isPaired ? <PagePlayer /> : <PageSignIn />;
};

export const App = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Toaster richColors position="top-right" />
      <Routes>
        <Route index element={<Home />} />
        <Route path="reset" element={<ResetRoute />} />
        <Route path="info" element={<InfoRoute />} />
        {/* Everything else, including the old /auth/login start URL, lands on "/". */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
};
